<template>
  <div>
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        module="basic"
        url="systemLogs">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="操作人">
            <el-input v-model.trim="filter.operator" placeholder="请输入" clearable/>
          </vm-search>
          <vm-search label="操作模块">
            <el-input v-model.trim="filter.logger" placeholder="请输入" clearable/>
          </vm-search>
          <vm-search label="操作类型">
            <el-input v-model.trim="filter.logType" placeholder="请输入" clearable/>
          </vm-search>
          <vm-search label="操作描述">
            <el-input v-model.trim="filter.description" placeholder="请输入" clearable/>
          </vm-search>
          <vm-search label="操作日期">
            <el-date-picker
                v-model="createDate"
                :picker-options="pickerOptions"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="createDateChange"/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="createdTime" label="操作时间" width="150"/>
      <el-table-column prop="employeeName" label="操作人" width="100"/>
      <el-table-column prop="logger" label="操作模块" width="200"/>
      <el-table-column prop="logType" label="操作类型" width="160"/>
      <el-table-column
          prop="description"
          label="操作描述">
        <template slot-scope="scope">
          <el-tooltip
              :content="scope.row.description"
              :hide-after="15000"
              enterable
              placement="top">
            <span class="text-overflow-ellipsis">{{scope.row.description}}</span>
          </el-tooltip>
        </template>
      </el-table-column>
    </vm-table>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import constant from "@/util/constant";
  import auth from "@/util/loginUtil";

  export default {
    name: "SystemLogList",
    components: {VmTable, VmSearch},
    data() {
      return {
        constant,
        authName: auth.getUserName(),
        currentUserId: auth.getUserId(),
        pickerOptions: {
          shortcuts: [{
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          }],
        },
        selections: [],
        createDate: [],
        filter: {
          operator: "",
          operationType: "",
          logType: "",
          logger: "",
          description: "",
          createdTimeStart: "",
          createdTimeEnd: "",
        },
      };
    },

    mounted() {
      this.getList(1);
    },

    methods: {
      getList(pageNo) {
        this.$refs.vmTable.getList(pageNo);
      },
      createDateChange(date) {
        if (date !== null) {
          this.filter.createdTimeStart = date[0];
          this.filter.createdTimeEnd = date[1];
        } else {
          this.filter.createdTimeStart = "";
          this.filter.createdTimeEnd = "";
        }
      },
    },
  };
</script>

